import React, { useCallback } from 'react'
import ReactGA from 'react-ga'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import LoadDetailsTemplate from './components/LoadDetailsTemplate'
import useLoadDetailsHandler from './hooks/useLoadDetailsHandler'
import { allLoadSelector } from '../../redux/loads/allAvaliableSelector'

ReactGA.pageview('/load-details')

const mapDetailsRoute = {
  'all-loads': {
    page: 'loads',
    module: 'all'
  },
  'my-loads': {
    page: 'loads',
    module: 'my'
  },
  'my-offers': {
    page: 'offers',
    module: 'myOffers'
  },
  'offers-history': {
    page: 'offers',
    module: 'history'
  },
  'assigned-orders': {
    page: 'orders',
    module: 'assigned'
  },
  'ready-to-invoice': {
    page: 'orders',
    module: 'ready'
  }
}

const getModuleRouteParams = (module) => mapDetailsRoute[module] || { page: 'main' }

const LoadDetails = ({ route, navigation }) => {
  const { filters } = useSelector(allLoadSelector)

  const onGoBack = useCallback(() => {
    const { page, module } = getModuleRouteParams(route?.params?.module)
    navigation.navigate(page, module && { screen: module })
  }, [navigation, route])

  const handleOpenSection = useCallback((open) => {
    if (!open) onGoBack()
  }, [onGoBack])

  const { details, loading } = useLoadDetailsHandler(route.params, handleOpenSection)

  return route.name === 'load-details' && details.load ? (
    <LoadDetailsTemplate
      details={details}
      onGoBack={onGoBack}
      loading={loading}
      isGroup={filters.isGroup && route.params.module === 'all-loads'}
      module={route.params.module}
    />
  ) : null
}

LoadDetails.propTypes = {
  route: PropTypes.object,
  navigation: PropTypes.object
}

export default LoadDetails
